<footer>
  <div class="footer-text">{{language.copyrightNotice}}</div>
</footer>